import { IsoFooterSectionProps } from "@/src/sections/iso-footer";


const generateImagePaths = (
   count: number,
   color: string
): { img: string }[] => {
   return Array.from({ length: count }, (_, i) => ({
      img: `/assets/images/iso/${color}/${i + 1}.png`,
   }));
};

export const IsoFooterSectionData_en: IsoFooterSectionProps = {
   sectionHeading: {
      subtitle: "services",
      title: "Raising the bar for business with technological innovation",
   },
   cards: [...generateImagePaths(27, "blue")],
};
